var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDownV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 1.49219L6.58984 6.49609C6.42578 6.63281 6.26172 6.6875 6.125 6.6875C5.96094 6.6875 5.79688 6.63281 5.66016 6.52344L0.410156 1.49219C0.136719 1.24609 0.136719 0.808594 0.382812 0.5625C0.628906 0.289062 1.06641 0.289062 1.3125 0.535156L6.125 5.12891L10.9102 0.535156C11.1562 0.289062 11.5938 0.289062 11.8398 0.5625C12.0859 0.808594 12.0859 1.24609 11.8125 1.49219Z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownV2);
export default __webpack_public_path__ + "static/media/arrow-down-v2.9b5ce56b792ba61fdc9f20c0fc4c3071.svg";
export { ForwardRef as ReactComponent };